import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleRow from "@/components/feature/ArticleRow";
import { filterArticles } from "@/lib/media";

export default function LatestNewsSection() {
  const latest = filterArticles("全部").slice(0, 5);

  return (
    <section className="mt-12" aria-label="最新影视资讯">
      <SectionHeading
        eyebrow="Latest stories"
        title="最新影视资讯"
        subtitle="行业动态、深度影评与幕后专题，每天更新"
        actionLabel="全部资讯"
        actionTo="/news"
      />

      <div className="grid gap-6 lg:grid-cols-[1.15fr_1fr]">
        <Link
          to={`/news/detail/${latest[0].id}`}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
        >
          <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
            <img
              src={latest[0].thumbnail}
              alt={latest[0].title}
              title={`${latest[0].title} 影视资讯 色虎`}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
            />
          </div>
          <div className="flex flex-1 flex-col p-4">
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-700">{latest[0].category}</span>
              <span>{latest[0].date}</span>
              <span>{latest[0].author}</span>
            </div>
            <h3 className="mt-2 line-clamp-2 font-heading text-lg font-semibold leading-7 text-foreground-950 transition-colors group-hover:text-accent-600">
              {latest[0].title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-500">{latest[0].summary}</p>
          </div>
        </Link>

        <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-1">
          {latest.slice(1, 5).map((article) => (
            <ArticleRow key={article.id} article={article} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}